<script setup lang="ts">

import { defineProps } from 'vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import DeleteButton from '@/components/Elements/Buttons/DeleteButton.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import Backend from '@/models/backend.ts'
import router from '@/router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps({
  fleetId: {
    type: Number,
    required: true
  }
});

/**
 * Stores / models
 */
const gameStore = useGameStore();


/**
 * Functions
 */
const disbandFleet = () => {
  gameStore.modal2Type = 'confirmationDelete';
  gameStore.modal2Data = {
    title: t('command.fleets.disband.confirmTitle'),
    message: t('command.fleets.disband.confirmMessage'),
    actionText: t('command.fleets.disband.yes'),
    cancelText: t('command.fleets.disband.no'),
    action: () => {
      const backend = new Backend()
      backend.disbandFleet(props.fleetId).then(() => {
        gameStore.setTinySuccessToastMessage(t('notifications.success.fleetDisbanded'));
        router.push('/command/fleets/');
      });
    },
  };

};

</script>

<template>
  <StandardCard top-padding="2" :title="t('command.fleets.disband.title')" :help="t('command.fleets.disband.help')">
    <DeleteButton @click="disbandFleet">{{ t('command.fleets.disbandFleet') }}</DeleteButton>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>